unit TourEdit;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Storage,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Imaging.GIFImg, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls,
  XData.Web.Client, VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomControl, VCL.TMSFNCToolBar, WEBLib.WebCtrls, VCL.TMSFNCPageControl, VCL.TMSFNCTabSet,
  VCL.TMSFNCListBox, WEBLib.Lists, WEBLib.SignatureCapture, WebBasis, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCBitmapContainer, WebBasis2, WEBLib.Grids, VCL.TMSFNCButton;

[async] function DoTourEdit( aID_Tour : Integer ) : TModalResult; async;


type
  TfrmTourEdit = class(TfrmWebBasis)
    WebPanel1: TPanel;
    lbTau: TLabel;
    lbBeladung: TLabel;
    lbEntladung: TLabel;
    [async]
    pgContr: TTMSFNCPageControl;
    tabDaten: TTMSFNCPageControlContainer;
    mDaten: TMemo;
    tabDoku: TTMSFNCPageControlContainer;
    ImgContr: TImageControl;
    lbDokumentPos: TLabel;
    fpFilePicker: TFilePicker;
    cbxDokumente: TComboBox;
    btnDokumentDel: TTMSFNCToolBarButton;
    edtTourRef: TLabel;
    btnNavNext: TTMSFNCToolBarButton;
    btnNavPrev: TTMSFNCToolBarButton;
    edtBeginn: TLabel;
    edtEnde: TLabel;
    tabEmpfang: TTMSFNCPageControlContainer;
    sigCapt: TSignatureCapture;
    btnSignaturSpeichern: TTMSFNCToolBarButton;
    mInfoSign: TMemo;
    btnOK: TTMSFNCToolBarButton;
    btnAbbrechen: TTMSFNCToolBarButton;
    btnAkt: TTMSFNCToolBarButton;
    lbFzg1: TLabel;
    lbFzg2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    tabTau: TTMSFNCPageControlContainer;
    btnTourStart: TTMSFNCToolBarButton;
    btnTourStop: TTMSFNCToolBarButton;
    btnTourAktOK: TTMSFNCToolBarButton;
    btnTourAktNOK: TTMSFNCToolBarButton;
    respGrid: TResponsiveGrid;
    btnDownload: TTMSFNCToolBarButton;
    procedure fpFilePickerChange(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
     //
    [async] procedure WebFormShow(Sender: TObject); async;
    [async] procedure btnDokumentDelClick(Sender: TObject); async;
    [async] procedure fpFilePickerGetFileAsBase64(Sender: TObject; AFileIndex: Integer; ABase64: string); async;
    [async] procedure Daten_Laden; async;
    [async] procedure Dokumente_Laden; async;
    [async] procedure Bild_Anzeigen; async;
    [async] procedure Form_Uebersetzen; async;
    [async] procedure btnSignaturSpeichernClick(Sender: TObject); async;
    [async] procedure btnAktClick(Sender: TObject); async;
    [async] procedure btnTourMeldungClick(Sender: TObject); async;
    [async] procedure btnTourAktionClick(Sender: TObject); async;
    [async] procedure btnPDFClick(Sender: TObject); async;
     //
    procedure DoDokumentNav(Sender: TObject);
    procedure pgContrChangePage(Sender: TObject; APreviousPageIndex, ACurrentPageIndex: Integer);
    procedure cbxDokumenteChange(Sender: TObject);
    procedure btnOKClick(Sender: TObject);
    procedure ImgContrDblClick(Sender: TObject);
    procedure respGridItemTauEditClick(Sender: TObject; Index: Integer);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);




  private
    iID_AktDok : Integer;
    sDokTyp : String;
    iID_Zugm : Integer;
    iID_ANH  : Integer;
    function Get_SQL_Ladestellen( aID_Tau : Integer ) : String;
    procedure Form_Anpassen;
    procedure Opt_Speichern;
    procedure Opt_Laden;


  public
    iID_Tour : Integer;
  protected procedure LoadDFMValues; override; end;

var frmTourEdit: TfrmTourEdit;

const cFormTourEdit = 'TOUREDIT_';

implementation

{$R *.dfm}

uses UnitMain, Konstanten, GlobalWeb , SpediFucsDatenmodul , ShowGrafik, GetStammdaten, Tour, TauEdit;


//====================================================================================================================//

function DoTourEdit( aID_Tour : Integer ) : TModalResult;
begin

  frmMainForm.mMainMenu.Enabled := False;

  frmTourEdit := TfrmTourEdit.Create(application);
  frmTourEdit.Popup   := True;
  //frmTauEdit.Border  := fbDialogSizeable;
  frmTourEdit.iID_Sprache := frmMainForm.iID_Sprache;
  frmTourEdit.iID_Tour := aID_Tour;

  // used to manage Back button handling to close subform
  window.location.hash := 'subform';


  await( TfrmTourEdit, frmTourEdit.Load() );  //load file HTML template + controls      macht CreateForm und FormShow

  frmTourEdit.Resize;

  Try

    await( TModalResult, frmTourEdit.Execute);  // excute form and wait for close

    Result := frmTourEdit.ModalResult;

    //Änderungen speichern
    //If Result = mrOK then  // frmTauEdit.Daten_Speichern;
    //Showmessage(frmTauEdit.mDaten.Text);
//
  Finally
    frmTourEdit.Free;
  End;

  frmMainForm.mMainMenu.Enabled := True;

end;


//====================================================================================================================//

procedure TfrmTourEdit.Opt_Speichern;
begin

  TLocalStorage.SetValue( cFormTourEdit+'PAGE', IntToStr(pgContr.ActivePageIndex) );

end;

//====================================================================================================================//

procedure TfrmTourEdit.Opt_Laden;
begin
  pgContr.ActivePageIndex := StrToIntDef( TLocalStorage.GetValue( cFormTourEdit+'PAGE' )  ,0);

end;


//====================================================================================================================//

procedure TfrmTourEdit.btnOKClick(Sender: TObject);
begin
  inherited;

  If Sender = btnOK then ModalResult := mrOK
  Else ModalResult := mrCancel;

  Close;

end;

//====================================================================================================================//

procedure TfrmTourEdit.btnPDFClick(Sender: TObject);
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sDatei : String;
    aGuiObj : TCoreGuiObj;
    iID : Integer;
    am : TMemoryStream;
    mr : TModalResult;
begin
  inherited;

  If cbxDokumente.ItemIndex = -1 then Exit;
  If cbxDokumente.Items.Count = 0 then Exit;

  aGuiObj :=  TCoreGuiObj( cbxDokumente.Items.Objects[ cbxDokumente.ItemIndex ]);
  iID := aGuiObj.ID;


  If not WaitMessage.Showing then WaitMessage.Show;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
  Response := await( ClientConn.RawInvokeAsync('ISystemService.Get_DokumentDatei', [iID] ));
  ClientConn.Free;

  sDaten := JS.toString (TJSObject(Response.Result)['value']);
  //sDaten := await( Crypt( sDaten ) );

  WaitMessage.Hide;


  If Copy(sDaten,1,6)= 'FEHLER' then
    Begin
     mr := await(TModalResult, MessageDlgAsync('Das Dokument konnte nicht geladen werden...', mtInformation, [mbOK]));
    End
  Else
    Begin
      sDatei := cbxDokumente.Text;
      am := TMemoryStream.Create;
        TTMSFNCUtils.LoadStreamFromBase64( sDaten, am );
      am.SaveToFile(sDatei);
      am.Free;
    End;

end;

//====================================================================================================================//

procedure TfrmTourEdit.Dokumente_Laden;
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sSQL, sTmp : String;
    aSL, aSL_Daten : TStringList;
    i, iAnz, iAnzDok  : Integer;
    aGuiObj :  TCoreGuiObj;
    aArray : TArray<string>;
begin

  If not WaitMessage.Showing then WaitMessage.Show;


  sSQL :='01:SELECT ID_DOKUMENT, BEZEICHNUNG, INS_AM, ID_DOK_TYP FROM DOKUMENT D '
           +' WHERE ID_DOK_BEZ=(SELECT ID_DOK_BEZ FROM TOUR WHERE ID_TOUR='+IntToStr(self.iID_Tour)+');' ;

  sSQL := await(  Crypt( sSQL )  );

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL,1,50 ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aSL_Daten := TStringList.Create;
  aSL_Daten.Text := await( Crypt( sDaten ));

  aSL := TStringList.Create;

  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');

  cbxDokumente.Items.clear;

  For i := 2 to aSL.Count -1 Do
    Begin
       sTmp := aSL[i];
       aArray := sTmp.Split([';']);
       If sDokTyp<>'' then
         If sDokTyp <> aArray[3] then Continue;
       aGuiObj :=  TCoreGuiObj.Create;
       aGuiObj.ID := StrToIntDef( aArray[0],0 );
       aGuiObj.Bezeichnung := aArray[1];
       cbxDokumente.Items.AddObject( aArray[1], aGuiObj );
    End;

  iAnzDok := cbxDokumente.Items.Count;
  cbxDokumente.Enabled   := (iAnzDok>0);
  btnDokumentDel.Enabled := (iAnzDok>0);

  lbDokumentPos.Caption := '0/0';

  If iAnzDok > 0 then
    Begin
      cbxDokumente.ItemIndex :=  (iAnzDok-1);
      lbDokumentPos.Caption := IntToStr( cbxDokumente.ItemIndex+1 ) +'/' +IntToStr( cbxDokumente.Items.Count );
    End;

  aSL.Free;
  aSL_Daten.Free;

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmTourEdit.btnAktClick(Sender: TObject);
begin
  await(  Dokumente_Laden );
  await(  Bild_Anzeigen );
end;

//====================================================================================================================//

procedure TfrmTourEdit.btnDokumentDelClick(Sender: TObject);
var aGuiObj : TCoreGuiObj;
    ClientConn : TXDataWebClient;
    Response: TXDataClientResponse;
    Blob: JSValue;
    sImgBase64, sDaten : String;
    iID, iErg : Integer;
    res: TModalResult;
begin


  If cbxDokumente.ItemIndex = -1 then Exit;
  If cbxDokumente.Items.Count = 0 then Exit;

  res := await(TModalResult, MessageDlgAsync('Dokument löschen ?', mtConfirmation, [mbYes, mbNo]));
  if res <> mrYes then Exit;


  If not WaitMessage.Showing then WaitMessage.Show;

  aGuiObj :=  TCoreGuiObj( cbxDokumente.Items.Objects[ cbxDokumente.ItemIndex ]);
  iID := aGuiObj.ID;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
  Response := await( ClientConn.RawInvokeAsync('ISystemService.Del_DokumentDatei', [iID] ));
  ClientConn.Free;

  cbxDokumente.Items.Delete(cbxDokumente.ItemIndex);
  cbxDokumente.ItemIndex :=  cbxDokumente.Items.Count-1;

  ImgContr.Clear;

  await( Bild_Anzeigen );

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmTourEdit.btnSignaturSpeichernClick(Sender: TObject);
var sDateiName, sBase64 : String;
    Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    mr : TModalResult;
begin
  inherited;


  sDateiName := 'Sign_'+IntToStr(self.iID_Tour)+'_'+FormatDateTime('yymmdd_hhnnss', Now) + '.PNG';


  sBase64 :=  sigCapt.GetAsBase64Image;
//  sBase64 := 'data:image/png;base64,' + sBase64;

  sBase64 := Trim( Copy( sBase64, 23, Length(sBase64)) );


  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

  Response := await( ClientConn.RawInvokeAsync('ISystemService.Set_Dokument', [ sBase64, sDateiName, c_Tour, iID_Tour  ] ));

  ClientConn.Free;


  mr := await(TModalResult, MessageDlgAsync('Die Signatur wurde gespeichert', mtConfirmation, [mbOK]));
  //If mr = mrOK then  btnSignaturSpeichern.Enabled := False;

end;

//====================================================================================================================//

procedure TfrmTourEdit.btnTourAktionClick(Sender: TObject);
var iID , iTab, iMldArt  : Integer;
    ClientConn: TXDataWebClient;
    Response: TXDataClientResponse;
    aParam : TParam;
begin
  inherited;

//  kennung = 1
//  wert 0 oder 1
  //
  aParam := TParam.Create;
  aParam.Integer1 := 1;  // Kennung 1 = Tour-Aktionen
  aParam.Integer2 := BToI(  (Sender=btnTourAktOK) );  // Wert 0=NOK  1=OK
  aParam.ID_Tour := self.iID_Tour;
  aParam.ID_Mab := StrToIntDef( frmMainForm.BenutzerMaNr, 0);
  aParam.Datum1 := Now;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.Set_TourAktion', [ aParam  ] ));
  ClientConn.Free;


  If Sender= btnTourAktOK then
    Begin
      mDaten.Lines.Add( FormatDateTime('dd.mm.yyyy hh:nn', aParam.Datum1) + ' - OK');
      //btnTourAktOK.Enabled := False;
    End;

  If Sender= btnTourAktNOK then
    Begin
      mDaten.Lines.Add( FormatDateTime('dd.mm.yyyy hh:nn', aParam.Datum1) + ' - NOK');
      //btnTourAktNOK.Enabled := False;
    End;

 aParam.Free;

end;

//====================================================================================================================//

procedure TfrmTourEdit.btnTourMeldungClick(Sender: TObject);
var iID , iTab, iMldArt  : Integer;
    ClientConn: TXDataWebClient;
    Response: TXDataClientResponse;
    aParam : TParam;
    sBez : String;
begin
  inherited;

  iTab := c_Fzg;
  iID := 0;
  iMldArt := 0;
  sBez := '';
  If Sender= btnTourStart then iMldArt := -100;
  If Sender= btnTourStop  then iMldArt := -80 ;

  Try                                            // bei Stop kein Kennzeichen abfragen
    If Sender= btnTourStart then
        await( Get_Stammdaten( iTab, iID, sBez ) )
    Else iID := -1;
  Finally

    If iID <> 0 then
      Begin
        If Sender= btnTourStop then iID := 0;

        aParam := TParam.Create;
        aParam.Integer1 := iMldArt;  // Start/Stop
        aParam.ID_Tour := self.iID_Tour;
        aParam.ID_Fahrzeug := iID;
        aParam.ID_Mab := StrToIntDef( frmMainForm.BenutzerMaNr, 0);
        aParam.Datum1 := Now;

        ClientConn := TXDataWebClient.Create(nil);
        ClientConn.Connection := frmMainForm.XDataConn;
          Response := await( ClientConn.RawInvokeAsync('ISystemService.Set_TourMeldung', [ aParam  ] ));
        ClientConn.Free;

        If Sender= btnTourStart then
          Begin
            mDaten.Lines.Add( FormatDateTime('dd.mm.yyyy hh:nn', aParam.Datum1) + ' - Start');
            btnTourStart.Enabled := False;
          End;

        If Sender= btnTourStop then
          Begin
            mDaten.Lines.Add( FormatDateTime('dd.mm.yyyy hh:nn', aParam.Datum1) + ' - Stop');
            btnTourStop.Enabled := False;
          End;

       aParam.Free;

      End;

  End;

end;

//====================================================================================================================//

procedure TfrmTourEdit.cbxDokumenteChange(Sender: TObject);
begin
  inherited;
  Bild_Anzeigen;
end;

//====================================================================================================================//

procedure TfrmTourEdit.Daten_Laden;
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sSQL, sTmp, sText, sKopfZeile: String;
    aSL, aSL_Daten : TStringList;
    aStream : TStream;
    aTMP :  TJSObject;
    i, iAnz, iAnzDok, iTop : Integer;
    aGuiObj :  TCoreGuiObj;
    aArray : TArray<string>;
    li: TListItem;
    aItem : TResponsiveGridItem;
begin

  console.log('TfrmTourEdit.Daten_Laden - Start '+IntToStr(self.iID_Tour) );

  If not WaitMessage.Showing then WaitMessage.Show;


  //                        0         1         2          3      4        5       6       7          8
  sSQL := '01:SELECT T.ID_TOUR, T.REF_NR, T.BEGINN, T.ENDE, T.INFO, T.INFO2, T.INFO3, T.KND_AUFTR_NR, T.ZIEL,  '

       +' (SELECT NAME1 || IIF(NAME2 is null,'+cH+cH+', '+cH+', '+cH+' || NAME2 ) '
       +'   FROM MITARBEITER M, ADRESSE A  WHERE M.ID_ADRESSE=A.ID_ADRESSE AND M.ID_MITARBEITER=T.ID_FAHRER1 ) AS FAHRER1,  '  // 9
       +' (SELECT NAME1 || IIF(NAME2 is null,'+cH+cH+', '+cH+', '+cH+' || NAME2 ) '
       +'   FROM MITARBEITER M, ADRESSE A  WHERE M.ID_ADRESSE=A.ID_ADRESSE AND M.ID_MITARBEITER=T.ID_FAHRER2 ) AS FAHRER2,'   // 10
       +' (SELECT NAME1 FROM KUNDE K, ADRESSE A  WHERE K.ID_ADRESSE=A.ID_ADRESSE AND K.ID_KUNDE=T.ID_KUNDE ) AS KUNDE,'       // 11
       +' (SELECT BEZEICHNUNG FROM UEBENE1 U1 WHERE U1.ID_UEBENE1=T.ID_UEBENE1) as UEBENE1, '
       +' (SELECT BEZEICHNUNG FROM UEBENE2 U2 WHERE U2.ID_UEBENE2=T.ID_UEBENE2) as UEBENE2, '
       +' (SELECT KENNZEICHEN FROM FAHRZEUG F WHERE F.ID_FAHRZEUG=T.ID_FAHRZEUG1 ) as KENNZEICHEN1, '  // 14
       +' (SELECT KENNZEICHEN FROM FAHRZEUG F WHERE F.ID_FAHRZEUG=T.ID_FAHRZEUG2 ) as KENNZEICHEN2, '
       +' (SELECT TOURNAME FROM TOUR_NAME N WHERE N.ID_TOUR_NAME=T.ID_TOUR_NAME ) as TOURNAME, '   //16
       +'  ID_FAHRZEUG1, ID_FAHRZEUG2, ID_FAHRZEUG3, ID_FAHRER1, ID_FAHRER2, ID_FAHRER3 '   // 17  18  19   20 21 22
       + ' FROM TOUR T WHERE ID_TOUR='+IntToStr(self.iID_Tour)+';'

     +'02:SELECT ID_DOKUMENT, BEZEICHNUNG, INS_AM, ID_DOK_TYP FROM DOKUMENT D WHERE ID_DOK_BEZ=(SELECT ID_DOK_BEZ FROM TOUR WHERE ID_TOUR='+IntToStr(self.iID_Tour)+');'

     +'03:SELECT WERT FROM OPTIONEN WHERE BEREICH='+cH+'OPT_ONLINE'+cH +' AND FELD='+cH+'DOKTYP_TAU_LFT'+cH+';'

     +'04:SELECT IIF(WERT IS NULL,0,WERT) AS WERT, INS_AM AS ZEITPUNKT FROM MOBILTOURAKT WHERE KENNUNG=1 AND ID_TOUR ='+IntToStr(self.iID_Tour)
     +'   UNION '
     +'   SELECT ID_TOUR_MLD_ART AS WERT, ZEITPUNKT FROM TOUR_MLD WHERE ID_TOUR='+IntToStr(self.iID_Tour)+' ORDER BY 2 '  +';'


    + '05:SELECT T.ID_TAU, T.REF_NR, T.KND_AUFTR_NR, T.BELADUNG_AM, T.ENTLADUNG_AM, '
         +' (SELECT RNGREF FROM LFTRNG R WHERE T.ID_LFTRNG=R.ID_LFTRNG ) as LFT_RNG, '   //  5
         +' (SELECT ADR_TEXT  FROM GET_ADRESSE( BELADUNG_ID_ADR)) AS BELADESTELLE, '     //  6
         +' (SELECT ADR_TEXT  FROM GET_ADRESSE( ENTLADUNG_ID_ADR)) AS ENTLADESTELLE, '   //  7
         +' (SELECT ADR_NAME1 FROM GET_ADRESSE( BELADUNG_ID_ADR))  AS BELADE_NAME, '      // 8
         +' (SELECT ADR_NAME1 FROM GET_ADRESSE( ENTLADUNG_ID_ADR)) AS ENTLADE_NAME '    //   9
         + ' FROM TOUR TR, TOUR_POS P, TAU T, KUNDE K '
         +'  WHERE TR.ID_TOUR=P.ID_TOUR AND P.ID_TAU=T.ID_TAU AND T.ID_KUNDE=K.ID_KUNDE '
         + ' AND TR.ID_TOUR ='+IntToStr(self.iID_Tour)  +';';




  sSQL := await(  Crypt( sSQL )  );

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL,1,50 ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aSL_Daten := TStringList.Create;
  aSL_Daten.Text := await( Crypt( sDaten ));

  aSL := TStringList.Create;

  mDaten.Clear;
  mInfoSign.Clear;




  // Tour ---------------------------------------------------------
  //
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');

  sTmp := aSL[2];
  aArray := sTmp.Split([';']);

  edtTourRef.Caption := aArray[1];
  edtBeginn.Caption := Copy( aArray[2],1,16);
  edtEnde.Caption   := Copy( aArray[3],1,16);

  lbFzg1.Caption := aArray[14] ;
  lbFzg2.Caption := aArray[15] ;
  iID_Zugm :=  StrToIntDef( aArray[17], 0 ) ;
  iID_Anh  :=  StrToIntDef( aArray[18], 0 ) ;


  If aArray[9]  <> '' then mDaten.Lines.Add( 'Fahrer 1:  ' +aArray[9] );
  If aArray[10] <> '' then mDaten.Lines.Add( 'Fahrer 2:  ' +aArray[10] );

  mDaten.Lines.Add('');

  mDaten.Lines.Add( Transl(80,'Kundenauftrag')+': '+ aArray[7] );
  mDaten.Lines.Add( Transl(80,'Ziel')+': '+ aArray[8] );
  mDaten.Lines.Add( Transl(80,'Info')+': '+ aArray[4] );
  mDaten.Lines.Add( Transl(80,'Info2')+': '+ aArray[5] );
  mDaten.Lines.Add( Transl(80,'Info3')+': '+ aArray[6] );
  mDaten.Lines.Add( '' );


  // Option Dokumententyp -----------------------------------------------------
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '03');
  sTmp := aSL[2];
  aArray := sTmp.Split([';']);
  sDokTyp := aArray[0];


  // Start-Stop-Meldungen lesen
  //
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '04');
  If iAnz>2 then mDaten.Lines.Add( 'Tour-Meldungen' );

  For i := 2 to aSL.Count -1 Do
    Begin
       sTmp := aSL[i];
       aArray := sTmp.Split([';']);
       sTmp := Copy(aArray[1],1,16) ;

       If aArray[0] ='-100' then
         Begin
           btnTourStart.Enabled := False;
           sTmp := sTmp + ' - ' + Transl(130,'Start');
         End;
       If aArray[0] ='-80'  then
         Begin
           btnTourStop.Enabled := False;
           sTmp := sTmp + ' - ' + Transl(130,'Stop');
         End;
       If aArray[0] ='0'  then
         Begin
           //btnTourAktNOK.Enabled := False;
           sTmp := sTmp + ' - ' + Transl(130,'NOK');
         End;
       If aArray[0] ='1'  then
         Begin
           //btnTourAktOK.Enabled := False;
           sTmp := sTmp + ' - ' + Transl(130,'OK');
         End;

       mDaten.Lines.Add( sTmp );
    End;
  If iAnz>2 then   mDaten.Lines.Add('');


  // Transportaufträge der Tour
  //
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '05');
  If iAnz>2 then
  For i := 2 to aSL.Count -1 Do
    Begin
       sTmp := aSL[i];
       aArray := sTmp.Split([';']);

      sText := '<p><strong>'+Copy( aArray[3],1,16) + '</strong> - '+aArray[1]+'<br />'
               +aArray[6]+'<br />' + aArray[7]+'</p>';

      aItem := respGrid.Items.Add;
      aItem.HTML := sText;
      aItem.Tag :=  StrToIntDef(aArray[0],0);

       mDaten.Lines.Add( aArray[1] );
    End;


  // Dokumente -----------------------------------------------------------------
  await( Dokumente_Laden );
  If pgContr.ActivePageIndex = 2 then await(  Bild_Anzeigen );

  aSL.Free;
  aSL_Daten.Free;

  If not bUebersetzt then Form_Uebersetzen;

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmTourEdit.DoDokumentNav(Sender: TObject);
var iIdx, iAnz : Integer;
begin

  If cbxDokumente.Items.Count=0 then Exit;

  iIdx := cbxDokumente.ItemIndex;
  Inc(iIdx);
  iAnz := cbxDokumente.Items.Count;

  If Sender = btnNavNext then
    Begin
      If iIdx = iAnz then Exit;
      cbxDokumente.ItemIndex := cbxDokumente.ItemIndex +1;
    End
  Else
    Begin
      If iIdx = 1 then Exit;
      cbxDokumente.ItemIndex := cbxDokumente.ItemIndex -1;
    End;

  Bild_Anzeigen;

end;

//====================================================================================================================//

procedure TfrmTourEdit.fpFilePickerChange(Sender: TObject);
begin
  fpFilePicker.Files[0].GetFileAsBase64;
end;

//====================================================================================================================//

procedure TfrmTourEdit.fpFilePickerGetFileAsBase64(Sender: TObject; AFileIndex: Integer; ABase64: string);
var sBase64, sDateiName , sExt : String;
    aFile : TFile;
    Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
begin

  aFile :=  fpFilePicker.Files[AFileIndex];
  sExt  := UpperCase( ExtractFileext(aFile.Name) );

  If (sExt='.PNG') or (sExt='.JPG') or (sExt='.JPEG') or (sExt='.BMP')  then
    Begin
      sBase64 := c_ImgVorsatz + ABase64;
      ImgContr.url := sBase64;
    End;


  sDateiName := aFile.Name;
  sDateiName := 'D'+IntToStr(self.iID_Tour)+'_'+FormatDateTime('yymmdd_hhnnss', Now)   + sExt;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.Set_Dokument', [ ABase64, sDateiName, c_Tour, iID_Tour  ] ));
  ClientConn.Free;

  TFile(fpFilePicker.Files[AFileIndex]).Name := sDateiName;



  await( Daten_Laden );

end;

//====================================================================================================================//

procedure TfrmTourEdit.Bild_Anzeigen;
var aGuiObj : TCoreGuiObj;
    ClientConn : TXDataWebClient;
    Response: TXDataClientResponse;
    Blob: JSValue;
    sImgBase64, sDaten, sExt : String;
    iID : Integer;
    mr : TModalResult;
begin

  If cbxDokumente.Items.Count=0 then lbDokumentPos.Caption := '0/0';

  If cbxDokumente.ItemIndex = -1 then Exit;
  If cbxDokumente.Items.Count = 0 then Exit;

  aGuiObj :=  TCoreGuiObj( cbxDokumente.Items.Objects[ cbxDokumente.ItemIndex ]);
  iID := aGuiObj.ID;

  // Bild schon geladen ?
  If iID = iID_AktDok then Exit;

  // Grafik-Format ?
  sExt := UpperCase( ExtractFileExt( aGuiObj.Bezeichnung ) );

  //btnPDF.Enabled := (sExt='.PDF');

  If (sExt<>'.JPG') and (sExt<>'.JPEG') and (sExt<>'.PNG') and (sExt<>'.BMP') and (sExt<>'.GIF') then Exit;



  If not WaitMessage.Showing then WaitMessage.Show;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
  Response := await( ClientConn.RawInvokeAsync('ISystemService.Get_DokumentDatei', [iID] ));
  ClientConn.Free;

  sDaten := JS.toString (TJSObject(Response.Result)['value']);
  //sDaten :=  await( Crypt( sDaten ));

  WaitMessage.Hide;

  If Copy(sDaten,1,6)= 'FEHLER' then
    Begin
     mr := await(TModalResult, MessageDlgAsync('Das Dokument konnte nicht geladen werden...', mtInformation, [mbOK]));
    End
  Else
    Begin
      sImgBase64 := c_ImgVorsatz + sDaten;
      ImgContr.URL := sImgBase64;
    End;

  iID_AktDok := iID;

  lbDokumentPos.Caption := IntToStr( cbxDokumente.ItemIndex+1 ) +'/' +IntToStr( cbxDokumente.Items.Count );


  Form_Anpassen;

end;

//====================================================================================================================//

procedure TfrmTourEdit.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Opt_Speichern;
  inherited;

end;

//====================================================================================================================//

procedure TfrmTourEdit.WebFormCreate(Sender: TObject);
begin
  inherited;
  Opt_Laden;
end;

//====================================================================================================================//

procedure TfrmTourEdit.WebFormResize(Sender: TObject);
begin

  Form_Anpassen;

end;

//====================================================================================================================//

procedure TfrmTourEdit.Form_Anpassen;
var iZielBreite : Integer;
begin

  // Form
  self.Left   := 0;
  self.Top    := frmMainForm.pnlMenu.Top;
  self.Width  := window.InnerWidth;
  self.Height := window.InnerHeight-self.Top;



  // Komponenten
   iZielBreite := Trunc( self.Width * 0.95 );
   If iZielBreite > 500 then iZielBreite := 500;

   cbxDokumente.Width := iZielBreite - cbxDokumente.Left;

   fpFilePicker.Width := iZielBreite - fpFilePicker.Left;
   edtBeginn.Width  := iZielBreite - edtBeginn.Left;
   edtEnde.Width := iZielBreite - edtEnde.Left;

   sigCapt.Width := iZielBreite - sigCapt.Left;
   btnSignaturSpeichern.Width := iZielBreite - btnSignaturSpeichern.Left;
   mInfoSign.Width := iZielBreite - mInfoSign.Left;

   Console.Log('>> Form_Anpassen');
   lbDokumentPos.Left := cbxDokumente.Left + cbxDokumente.Width - lbDokumentPos.Width;

end;

//====================================================================================================================//

procedure TfrmTourEdit.WebFormShow(Sender: TObject);
begin

  WaitMessage.Show;

  iID_AktDok := 0;

  //pgContr.ActivePageIndex := 0;

  Sprach_Daten_Laden('TOUREDIT', frmMainForm.iID_Sprache );

  Daten_Laden;

  Form_Anpassen;

end;


//====================================================================================================================//

function TfrmTourEdit.Get_SQL_Ladestellen( aID_Tau : Integer ) : String;
begin


//  Result := 'SELECT WERT FROM OPTIONEN';
//  exit;

  Result :=

  'SELECT T.DATUM, T.POS, A.ADR_ART, A.NAME1, A.NAME2, A.NAME3, A.STRASSE, A.PLZ, A.ORT, T.INFO AS LADE_INFO, T.LADEGUT, '
  +' (SELECT L.LANDNAME FROM LAND L WHERE A.ID_LAND=L.ID_LAND) AS LANDNAME, T.ZEIT AS ZEIT_TXT,  '
  +'  '+cH+cH+' as ANSP_NAME, '  +'  '+cH+cH+' as ANSP_ZUNAME, '
  +'  '+cH+cH+' as ANSP_TEL, '+cH+cH + ' as ANSP_ANREDE '
  +' FROM TAU_ADR T, ADRESSE A WHERE T.ID_ADRESSE = A.ID_ADRESSE '
  +' AND T.ID_TAU ='+IntToStr( aID_Tau )

  +' UNION '

  +' SELECT T.BELADUNG_AM AS DATUM,  0 AS POS, A.ADR_ART, A.NAME1, A.NAME2, A.NAME3, A.STRASSE, A.PLZ, A.ORT, '
  +'  BELADUNG_INFO AS LADE_INFO, BELADUNG_LADEGUT AS LADEGUT, '
  +'  (SELECT L.LANDNAME FROM LAND L WHERE A.ID_LAND=L.ID_LAND) AS LANDNAME, BELADUNG_ZEIT AS ZEIT_TXT, '
  +'  (SELECT ZUNAME || '+cH+', '+cH+' || VORNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_NAME, '
  +'  (SELECT ZUNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_ZUNAME, '
  +'  (SELECT TELEFON FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_TEL, '
  +' CASE (SELECT ANREDE FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) '
  + ' WHEN 1 THEN '+cH+'Firma'+cH
  + ' WHEN 2 THEN '+cH+'Herr'+cH
  + ' WHEN 3 THEN '+cH+'Frau'+cH
  +'  ELSE '+cH+cH
  +' END as ANSP_ANREDE '
  +' FROM ADRESSE A, TAU T WHERE A.ID_ADRESSE=T.BELADUNG_ID_ADR AND T.ID_TAU='+IntToStr( aID_Tau )

  +' UNION '

  +' SELECT T.BELADUNG_AM AS DATUM,  0 AS POS, A.ADR_ART, A.NAME1, A.NAME2, A.NAME3, A.STRASSE, A.PLZ, A.ORT, '
  +'  BELADUNG_INFO AS LADE_INFO, BELADUNG_LADEGUT AS LADEGUT, '
  +'  (SELECT L.LANDNAME FROM LAND L WHERE A.ID_LAND=L.ID_LAND) AS LANDNAME, BELADUNG_ZEIT AS ZEIT_TXT, '
  +'  (SELECT ZUNAME || '+cH+', '+cH+' || VORNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_NAME, '
  +'  (SELECT ZUNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_ZUNAME, '
  +'  (SELECT TELEFON FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_TEL, '
  +' CASE (SELECT ANREDE FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) '
  + ' WHEN 1 THEN '+cH+'Firma'+cH
  + ' WHEN 2 THEN '+cH+'Herr'+cH
  + ' WHEN 3 THEN '+cH+'Frau'+cH
  +'  ELSE '+cH+cH
  +' END as ANSP_ANREDE '
  +' FROM ADRESSE A, TAU T WHERE A.ID_ADRESSE=T.ENTLADUNG_ID_ADR AND T.ID_TAU='+IntToStr( aID_Tau )


  +' ORDER BY 1 '; // T.DATUM, T.POS ' ;


end;


procedure TfrmTourEdit.ImgContrDblClick(Sender: TObject);
begin
  inherited;
  Show_Grafik( ImgContr.URL );
end;

//====================================================================================================================//

procedure TfrmTourEdit.pgContrChangePage(Sender: TObject; APreviousPageIndex, ACurrentPageIndex: Integer);
begin

  If aCurrentPageIndex = 2 then  Bild_Anzeigen;
  Form_Anpassen;

end;

//====================================================================================================================//

procedure TfrmTourEdit.respGridItemTauEditClick(Sender: TObject; Index: Integer);
var aItem : TResponsiveGridItem;
begin
  inherited;

  aItem := respGrid.Items[Index] ;

  //self.iID_Akt := aItem.Tag;

  Close;

  DoTauEdit( aItem.Tag, self.iID_Tour );

end;

//====================================================================================================================//

procedure TfrmTourEdit.Form_Uebersetzen;
begin

  If not tabSprachDaten.Active then
    Begin
     console.Log( 'Form_Uebersetzen in TfrmTauEdit -> NICHT OFFFEN');
     Exit;
    End;

  //console.Log( 'Form_Uebersetzen in TfrmTauEdit');

  If tabSprachDaten.Locate('NUMMER', 10, [] ) then lbTau.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;

  If tabSprachDaten.Locate('NUMMER', 30, [] ) then lbBeladung.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 40, [] ) then lbEntladung.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;

  If tabSprachDaten.Locate('NUMMER', 50, [] ) then pgContr.Pages[0].Text := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 60, [] ) then pgContr.Pages[1].Text := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 70, [] ) then pgContr.Pages[2].Text := tabSprachDatenBEGRIFF_UEB.AsString;

//  If tabSprachDaten.Locate('NUMMER', 120, [] ) then btnAbbrechen.Text := tabSprachDatenBEGRIFF_UEB.AsString;

  If tabSprachDaten.Locate('NUMMER', 140, [] ) then  btnSignaturSpeichern.Text := tabSprachDatenBEGRIFF_UEB.AsString;

 self.bUebersetzt := True;


end;


//====================================================================================================================//

procedure TfrmTourEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  lbTau := TLabel.Create(Self);
  lbBeladung := TLabel.Create(Self);
  lbEntladung := TLabel.Create(Self);
  edtTourRef := TLabel.Create(Self);
  edtBeginn := TLabel.Create(Self);
  edtEnde := TLabel.Create(Self);
  lbFzg1 := TLabel.Create(Self);
  lbFzg2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  btnOK := TTMSFNCToolBarButton.Create(Self);
  btnAbbrechen := TTMSFNCToolBarButton.Create(Self);
  pgContr := TTMSFNCPageControl.Create(Self);
  tabTau := TTMSFNCPageControlContainer.Create(Self);
  respGrid := TResponsiveGrid.Create(Self);
  tabEmpfang := TTMSFNCPageControlContainer.Create(Self);
  sigCapt := TSignatureCapture.Create(Self);
  btnSignaturSpeichern := TTMSFNCToolBarButton.Create(Self);
  mInfoSign := TMemo.Create(Self);
  tabDaten := TTMSFNCPageControlContainer.Create(Self);
  mDaten := TMemo.Create(Self);
  btnTourStart := TTMSFNCToolBarButton.Create(Self);
  btnTourStop := TTMSFNCToolBarButton.Create(Self);
  btnTourAktOK := TTMSFNCToolBarButton.Create(Self);
  btnTourAktNOK := TTMSFNCToolBarButton.Create(Self);
  tabDoku := TTMSFNCPageControlContainer.Create(Self);
  ImgContr := TImageControl.Create(Self);
  lbDokumentPos := TLabel.Create(Self);
  fpFilePicker := TFilePicker.Create(Self);
  cbxDokumente := TComboBox.Create(Self);
  btnDokumentDel := TTMSFNCToolBarButton.Create(Self);
  btnNavNext := TTMSFNCToolBarButton.Create(Self);
  btnNavPrev := TTMSFNCToolBarButton.Create(Self);
  btnAkt := TTMSFNCToolBarButton.Create(Self);
  btnDownload := TTMSFNCToolBarButton.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  lbTau.BeforeLoadDFMValues;
  lbBeladung.BeforeLoadDFMValues;
  lbEntladung.BeforeLoadDFMValues;
  edtTourRef.BeforeLoadDFMValues;
  edtBeginn.BeforeLoadDFMValues;
  edtEnde.BeforeLoadDFMValues;
  lbFzg1.BeforeLoadDFMValues;
  lbFzg2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  btnOK.BeforeLoadDFMValues;
  btnAbbrechen.BeforeLoadDFMValues;
  pgContr.BeforeLoadDFMValues;
  tabTau.BeforeLoadDFMValues;
  respGrid.BeforeLoadDFMValues;
  tabEmpfang.BeforeLoadDFMValues;
  sigCapt.BeforeLoadDFMValues;
  btnSignaturSpeichern.BeforeLoadDFMValues;
  mInfoSign.BeforeLoadDFMValues;
  tabDaten.BeforeLoadDFMValues;
  mDaten.BeforeLoadDFMValues;
  btnTourStart.BeforeLoadDFMValues;
  btnTourStop.BeforeLoadDFMValues;
  btnTourAktOK.BeforeLoadDFMValues;
  btnTourAktNOK.BeforeLoadDFMValues;
  tabDoku.BeforeLoadDFMValues;
  ImgContr.BeforeLoadDFMValues;
  lbDokumentPos.BeforeLoadDFMValues;
  fpFilePicker.BeforeLoadDFMValues;
  cbxDokumente.BeforeLoadDFMValues;
  btnDokumentDel.BeforeLoadDFMValues;
  btnNavNext.BeforeLoadDFMValues;
  btnNavPrev.BeforeLoadDFMValues;
  btnAkt.BeforeLoadDFMValues;
  btnDownload.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  try
    Width := 518;
    Height := 555;
    Color := 16776441;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 518;
    WebPanel1.Height := 119;
    WebPanel1.Align := alTop;
    WebPanel1.Color := 16776441;
    WebPanel1.TabOrder := 0;
    lbTau.SetParentComponent(WebPanel1);
    lbTau.Name := 'lbTau';
    lbTau.Left := 157;
    lbTau.Top := 5;
    lbTau.Width := 43;
    lbTau.Height := 18;
    lbTau.Caption := 'Tour:';
    lbTau.Font.Charset := ANSI_CHARSET;
    lbTau.Font.Color := clWindowText;
    lbTau.Font.Height := -15;
    lbTau.Font.Name := 'Verdana';
    lbTau.Font.Style := [fsBold];
    lbTau.HeightPercent := 100.000000000000000000;
    lbTau.ParentFont := False;
    lbTau.WidthPercent := 100.000000000000000000;
    lbBeladung.SetParentComponent(WebPanel1);
    lbBeladung.Name := 'lbBeladung';
    lbBeladung.Left := 16;
    lbBeladung.Top := 67;
    lbBeladung.Width := 43;
    lbBeladung.Height := 16;
    lbBeladung.Caption := 'Beginn';
    lbBeladung.HeightPercent := 100.000000000000000000;
    lbBeladung.WidthPercent := 100.000000000000000000;
    lbEntladung.SetParentComponent(WebPanel1);
    lbEntladung.Name := 'lbEntladung';
    lbEntladung.Left := 16;
    lbEntladung.Top := 94;
    lbEntladung.Width := 32;
    lbEntladung.Height := 16;
    lbEntladung.Caption := 'Ende';
    lbEntladung.HeightPercent := 100.000000000000000000;
    lbEntladung.WidthPercent := 100.000000000000000000;
    edtTourRef.SetParentComponent(WebPanel1);
    edtTourRef.Name := 'edtTourRef';
    edtTourRef.Left := 157;
    edtTourRef.Top := 26;
    edtTourRef.Width := 87;
    edtTourRef.Height := 18;
    edtTourRef.Caption := 'T0000000';
    edtTourRef.Font.Charset := ANSI_CHARSET;
    edtTourRef.Font.Color := clWindowText;
    edtTourRef.Font.Height := -15;
    edtTourRef.Font.Name := 'Verdana';
    edtTourRef.Font.Style := [fsBold];
    edtTourRef.HeightPercent := 100.000000000000000000;
    edtTourRef.ParentFont := False;
    edtTourRef.WidthPercent := 100.000000000000000000;
    edtBeginn.SetParentComponent(WebPanel1);
    edtBeginn.Name := 'edtBeginn';
    edtBeginn.Left := 65;
    edtBeginn.Top := 67;
    edtBeginn.Width := 71;
    edtBeginn.Height := 16;
    edtBeginn.Caption := 'T0000000';
    edtBeginn.Font.Charset := ANSI_CHARSET;
    edtBeginn.Font.Color := clWindowText;
    edtBeginn.Font.Height := -13;
    edtBeginn.Font.Name := 'Verdana';
    edtBeginn.Font.Style := [fsBold];
    edtBeginn.HeightPercent := 100.000000000000000000;
    edtBeginn.ParentFont := False;
    edtBeginn.WidthPercent := 100.000000000000000000;
    edtEnde.SetParentComponent(WebPanel1);
    edtEnde.Name := 'edtEnde';
    edtEnde.Left := 65;
    edtEnde.Top := 94;
    edtEnde.Width := 71;
    edtEnde.Height := 16;
    edtEnde.Caption := 'T0000000';
    edtEnde.Font.Charset := ANSI_CHARSET;
    edtEnde.Font.Color := clWindowText;
    edtEnde.Font.Height := -13;
    edtEnde.Font.Name := 'Verdana';
    edtEnde.Font.Style := [fsBold];
    edtEnde.HeightPercent := 100.000000000000000000;
    edtEnde.ParentFont := False;
    edtEnde.WidthPercent := 100.000000000000000000;
    lbFzg1.SetParentComponent(WebPanel1);
    lbFzg1.Name := 'lbFzg1';
    lbFzg1.Left := 265;
    lbFzg1.Top := 67;
    lbFzg1.Width := 71;
    lbFzg1.Height := 16;
    lbFzg1.Caption := 'T0000000';
    lbFzg1.Font.Charset := ANSI_CHARSET;
    lbFzg1.Font.Color := clWindowText;
    lbFzg1.Font.Height := -13;
    lbFzg1.Font.Name := 'Verdana';
    lbFzg1.Font.Style := [fsBold];
    lbFzg1.HeightPercent := 100.000000000000000000;
    lbFzg1.ParentFont := False;
    lbFzg1.WidthPercent := 100.000000000000000000;
    lbFzg2.SetParentComponent(WebPanel1);
    lbFzg2.Name := 'lbFzg2';
    lbFzg2.Left := 265;
    lbFzg2.Top := 94;
    lbFzg2.Width := 71;
    lbFzg2.Height := 16;
    lbFzg2.Caption := 'T0000000';
    lbFzg2.Font.Charset := ANSI_CHARSET;
    lbFzg2.Font.Color := clWindowText;
    lbFzg2.Font.Height := -13;
    lbFzg2.Font.Name := 'Verdana';
    lbFzg2.Font.Style := [fsBold];
    lbFzg2.HeightPercent := 100.000000000000000000;
    lbFzg2.ParentFont := False;
    lbFzg2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 213;
    WebLabel3.Top := 94;
    WebLabel3.Width := 36;
    WebLabel3.Height := 16;
    WebLabel3.Caption := 'Anh.:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel1);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 213;
    WebLabel4.Top := 67;
    WebLabel4.Width := 47;
    WebLabel4.Height := 16;
    WebLabel4.Caption := 'Zugm.:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    btnOK.SetParentComponent(WebPanel1);
    btnOK.Name := 'btnOK';
    btnOK.Left := 71;
    btnOK.Top := 5;
    btnOK.Width := 65;
    btnOK.Height := 44;
    btnOK.Cursor := crHandPoint;
    btnOK.ParentDoubleBuffered := False;
    btnOK.DoubleBuffered := True;
    btnOK.Font.Charset := ANSI_CHARSET;
    btnOK.Font.Color := clWindowText;
    btnOK.Font.Height := -13;
    btnOK.Font.Name := 'Verdana';
    btnOK.Font.Style := [];
    btnOK.ParentColor := True;
    btnOK.TabOrder := 0;
    SetEvent(btnOK, Self, 'OnClick', 'btnOKClick');
    btnOK.Text := '';
    btnOK.TextVisible := False;
    btnOK.Bitmaps.Clear;
    with btnOK.Bitmaps.Add do
    begin
      BitmapName := 'OK';
    end;
    btnOK.BitmapVisible := True;
    btnOK.BitmapContainer := BitmapCont;
    btnOK.ControlIndex := 0;
    btnAbbrechen.SetParentComponent(WebPanel1);
    btnAbbrechen.Name := 'btnAbbrechen';
    btnAbbrechen.Left := 3;
    btnAbbrechen.Top := 5;
    btnAbbrechen.Width := 65;
    btnAbbrechen.Height := 44;
    btnAbbrechen.Cursor := crHandPoint;
    btnAbbrechen.ParentDoubleBuffered := False;
    btnAbbrechen.DoubleBuffered := True;
    btnAbbrechen.Font.Charset := ANSI_CHARSET;
    btnAbbrechen.Font.Color := clWindowText;
    btnAbbrechen.Font.Height := -13;
    btnAbbrechen.Font.Name := 'Verdana';
    btnAbbrechen.Font.Style := [];
    btnAbbrechen.ParentColor := True;
    btnAbbrechen.TabOrder := 1;
    SetEvent(btnAbbrechen, Self, 'OnClick', 'btnOKClick');
    btnAbbrechen.Text := '';
    btnAbbrechen.TextVisible := False;
    btnAbbrechen.Bitmaps.Clear;
    with btnAbbrechen.Bitmaps.Add do
    begin
      BitmapName := 'CANCEL';
    end;
    btnAbbrechen.BitmapVisible := True;
    btnAbbrechen.BitmapContainer := BitmapCont;
    btnAbbrechen.ControlIndex := 0;
    pgContr.SetParentComponent(Self);
    pgContr.Name := 'pgContr';
    pgContr.Left := 0;
    pgContr.Top := 119;
    pgContr.Width := 518;
    pgContr.Height := 436;
    pgContr.Align := alClient;
    pgContr.ParentDoubleBuffered := False;
    pgContr.Color := clBtnFace;
    pgContr.DoubleBuffered := True;
    pgContr.TabOrder := 1;
    pgContr.ActivePageIndex := 2;
    pgContr.Fill.Kind := gfkNone;
    pgContr.Fill.Color := 16776441;
    pgContr.Stroke.Kind := gskNone;
    pgContr.TabAppearance.Font.Charset := ANSI_CHARSET;
    pgContr.TabAppearance.Font.Color := clWindowText;
    pgContr.TabAppearance.Font.Height := -13;
    pgContr.TabAppearance.Font.Name := 'Verdana';
    pgContr.TabAppearance.Font.Style := [];
    pgContr.TabAppearance.Fill.Color := clWhite;
    pgContr.TabAppearance.ActiveFill.Color := 16639703;
    pgContr.TabAppearance.DownFill.Color := 15776936;
    pgContr.TabAppearance.DownStroke.Color := 15702829;
    pgContr.TabAppearance.HoverFill.Color := 16380654;
    pgContr.TabAppearance.HoverStroke.Color := 15702829;
    pgContr.TabAppearance.TextSpacing := 0.000000000000000000;
    pgContr.TabAppearance.ActiveTextColor := 4539717;
    pgContr.TabAppearance.HoverTextColor := 8026746;
    pgContr.TabAppearance.DownTextColor := 4539717;
    pgContr.TabAppearance.ShowFocus := False;
    pgContr.TabAppearance.CloseStroke.Width := 2.000000000000000000;
    pgContr.TabAppearance.CloseDownStroke.Width := 2.000000000000000000;
    pgContr.TabAppearance.CloseHoverStroke.Width := 2.000000000000000000;
    pgContr.TabAppearance.BadgeFont.Charset := DEFAULT_CHARSET;
    pgContr.TabAppearance.BadgeFont.Color := clDarkred;
    pgContr.TabAppearance.BadgeFont.Height := -11;
    pgContr.TabAppearance.BadgeFont.Name := 'Segoe UI';
    pgContr.TabAppearance.BadgeFont.Style := [fsBold];
    pgContr.ButtonAppearance.CloseIcon.LoadFromFile('TourEdit.pgContr.ButtonAppearance.CloseIcon.svg');
    pgContr.ButtonAppearance.InsertIcon.LoadFromFile('TourEdit.pgContr.ButtonAppearance.InsertIcon.svg');
    pgContr.ButtonAppearance.TabListIcon.LoadFromFile('TourEdit.pgContr.ButtonAppearance.TabListIcon.svg');
    pgContr.ButtonAppearance.ScrollNextIcon.LoadFromFile('TourEdit.pgContr.ButtonAppearance.ScrollNextIcon.svg');
    pgContr.ButtonAppearance.ScrollPreviousIcon.LoadFromFile('TourEdit.pgContr.ButtonAppearance.ScrollPreviousIcon.svg');
    pgContr.Interaction.Reorder := True;
    pgContr.Options.TabListButton := True;
    pgContr.TabSize.Mode := tsmFixedSize;
    pgContr.TabSize.Width := 110.000000000000000000;
    pgContr.TabSize.Height := 40.000000000000000000;
    pgContr.TabSize.Margins.Left := 4.000000000000000000;
    pgContr.TabSize.Margins.Top := 4.000000000000000000;
    pgContr.TabSize.Margins.Right := 4.000000000000000000;
    pgContr.TabSize.Margins.Bottom := 8.000000000000000000;
    pgContr.Pages.Clear;
    with pgContr.Pages.Add do
    begin
      Text := 'Daten';
      Color := 16776441;
      UseDefaultAppearance := True;
    end;
    with pgContr.Pages.Add do
    begin
      Text := 'Auftr'#228'ge';
      UseDefaultAppearance := True;
    end;
    with pgContr.Pages.Add do
    begin
      Text := 'Dokumente';
      Color := 16776441;
      UseDefaultAppearance := True;
    end;
    with pgContr.Pages.Add do
    begin
      Text := 'Empfang';
      Color := 16776441;
      UseDefaultAppearance := True;
    end;
    SetEvent(pgContr, Self, 'OnChangePage', 'pgContrChangePage');
    tabTau.SetParentComponent(pgContr);
    tabTau.Name := 'tabTau';
    tabTau.AlignWithMargins := True;
    tabTau.Left := 0;
    tabTau.Top := 43;
    tabTau.Width := 518;
    tabTau.Height := 393;
    tabTau.Margins.Left := 0;
    tabTau.Margins.Top := 43;
    tabTau.Margins.Right := 0;
    tabTau.Margins.Bottom := 0;
    tabTau.Align := alClient;
    tabTau.ParentDoubleBuffered := False;
    tabTau.DoubleBuffered := True;
    tabTau.TabStop := False;
    tabTau.TabOrder := 3;
    tabTau.Visible := False;
    tabTau.PageIndex := 1;
    tabTau.IsActive := False;
    respGrid.SetParentComponent(tabTau);
    respGrid.Name := 'respGrid';
    respGrid.Left := 0;
    respGrid.Top := 0;
    respGrid.Width := 518;
    respGrid.Height := 393;
    respGrid.Cursor := crHandPoint;
    respGrid.ElementClassName := 'respgrid';
    respGrid.HeightStyle := ssAuto;
    respGrid.WidthStyle := ssPercent;
    respGrid.WidthPercent := 90.000000000000000000;
    respGrid.Align := alClient;
    respGrid.ChildOrder := 3;
    respGrid.Font.Charset := ANSI_CHARSET;
    respGrid.Font.Color := clWindowText;
    respGrid.Font.Height := -13;
    respGrid.Font.Name := 'Verdana';
    respGrid.Font.Style := [];
    respGrid.ItemIndex := 0;
    respGrid.Options.ItemClassName := 'respitem';
    respGrid.Options.ItemColor := 16639703;
    respGrid.Options.ItemHeight := 70;
    respGrid.Options.ItemHoverColor := 14811135;
    respGrid.Options.ItemSelectedColor := clBisque;
    respGrid.Options.ItemPadding := 10;
    respGrid.Options.ItemWidthMin := 260;
    respGrid.ParentFont := False;
    SetEvent(respGrid, Self, 'OnItemClick', 'respGridItemTauEditClick');
    tabEmpfang.SetParentComponent(pgContr);
    tabEmpfang.Name := 'tabEmpfang';
    tabEmpfang.AlignWithMargins := True;
    tabEmpfang.Left := 0;
    tabEmpfang.Top := 43;
    tabEmpfang.Width := 518;
    tabEmpfang.Height := 393;
    tabEmpfang.Margins.Left := 0;
    tabEmpfang.Margins.Top := 43;
    tabEmpfang.Margins.Right := 0;
    tabEmpfang.Margins.Bottom := 0;
    tabEmpfang.Align := alClient;
    tabEmpfang.ParentDoubleBuffered := False;
    tabEmpfang.Color := 16776441;
    tabEmpfang.DoubleBuffered := True;
    tabEmpfang.TabStop := False;
    tabEmpfang.TabOrder := 2;
    tabEmpfang.Visible := False;
    tabEmpfang.Fill.Color := 16776441;
    tabEmpfang.PageIndex := 3;
    tabEmpfang.IsActive := False;
    sigCapt.SetParentComponent(tabEmpfang);
    sigCapt.Name := 'sigCapt';
    sigCapt.Left := 9;
    sigCapt.Top := 80;
    sigCapt.Width := 500;
    sigCapt.Height := 229;
    sigCapt.Cursor := crHandPoint;
    sigCapt.TabOrder := 0;
    sigCapt.TextPosition.Line.Color := clGray;
    sigCapt.Text := 'hier unterschreiben';
    sigCapt.Pen.Width := 2;
    btnSignaturSpeichern.SetParentComponent(tabEmpfang);
    btnSignaturSpeichern.Name := 'btnSignaturSpeichern';
    btnSignaturSpeichern.Left := 9;
    btnSignaturSpeichern.Top := 331;
    btnSignaturSpeichern.Width := 500;
    btnSignaturSpeichern.Height := 40;
    btnSignaturSpeichern.Cursor := crHandPoint;
    btnSignaturSpeichern.ParentDoubleBuffered := False;
    btnSignaturSpeichern.DoubleBuffered := True;
    btnSignaturSpeichern.Font.Charset := ANSI_CHARSET;
    btnSignaturSpeichern.Font.Color := clWindowText;
    btnSignaturSpeichern.Font.Height := -13;
    btnSignaturSpeichern.Font.Name := 'Verdana';
    btnSignaturSpeichern.Font.Style := [];
    btnSignaturSpeichern.ParentColor := True;
    btnSignaturSpeichern.TabOrder := 1;
    SetEvent(btnSignaturSpeichern, Self, 'OnClick', 'btnSignaturSpeichernClick');
    btnSignaturSpeichern.Text := 'Speichern';
    btnSignaturSpeichern.ControlIndex := 0;
    mInfoSign.SetParentComponent(tabEmpfang);
    mInfoSign.Name := 'mInfoSign';
    mInfoSign.Left := 9;
    mInfoSign.Top := 8;
    mInfoSign.Width := 500;
    mInfoSign.Height := 66;
    mInfoSign.HeightPercent := 100.000000000000000000;
    mInfoSign.ReadOnly := True;
    mInfoSign.ScrollBars := ssVertical;
    mInfoSign.SelLength := 0;
    mInfoSign.SelStart := 0;
    mInfoSign.WidthPercent := 100.000000000000000000;
    tabDaten.SetParentComponent(pgContr);
    tabDaten.Name := 'tabDaten';
    tabDaten.AlignWithMargins := True;
    tabDaten.Left := 0;
    tabDaten.Top := 43;
    tabDaten.Width := 518;
    tabDaten.Height := 393;
    tabDaten.Margins.Left := 0;
    tabDaten.Margins.Top := 43;
    tabDaten.Margins.Right := 0;
    tabDaten.Margins.Bottom := 0;
    tabDaten.Align := alClient;
    tabDaten.ParentDoubleBuffered := False;
    tabDaten.Color := 16776441;
    tabDaten.DoubleBuffered := True;
    tabDaten.TabStop := False;
    tabDaten.TabOrder := 1;
    tabDaten.Visible := False;
    tabDaten.Fill.Color := 16776441;
    tabDaten.PageIndex := 0;
    tabDaten.IsActive := False;
    mDaten.SetParentComponent(tabDaten);
    mDaten.Name := 'mDaten';
    mDaten.Left := 11;
    mDaten.Top := 57;
    mDaten.Width := 504;
    mDaten.Height := 331;
    mDaten.Anchors := [akLeft,akTop,akRight,akBottom];
    mDaten.Font.Charset := ANSI_CHARSET;
    mDaten.Font.Color := clWindowText;
    mDaten.Font.Height := -13;
    mDaten.Font.Name := 'Verdana';
    mDaten.Font.Style := [];
    mDaten.HeightPercent := 100.000000000000000000;
    mDaten.ParentFont := False;
    mDaten.ReadOnly := True;
    mDaten.SelLength := 0;
    mDaten.SelStart := 0;
    mDaten.WidthPercent := 100.000000000000000000;
    btnTourStart.SetParentComponent(tabDaten);
    btnTourStart.Name := 'btnTourStart';
    btnTourStart.Left := 233;
    btnTourStart.Top := 7;
    btnTourStart.Width := 73;
    btnTourStart.Height := 44;
    btnTourStart.Cursor := crHandPoint;
    btnTourStart.ParentDoubleBuffered := False;
    btnTourStart.DoubleBuffered := True;
    btnTourStart.Font.Charset := ANSI_CHARSET;
    btnTourStart.Font.Color := clWindowText;
    btnTourStart.Font.Height := -13;
    btnTourStart.Font.Name := 'Verdana';
    btnTourStart.Font.Style := [];
    btnTourStart.ParentColor := True;
    btnTourStart.TabOrder := 1;
    SetEvent(btnTourStart, Self, 'OnClick', 'btnTourMeldungClick');
    btnTourStart.Text := 'Start';
    btnTourStart.BitmapContainer := BitmapCont;
    btnTourStart.ControlIndex := 0;
    btnTourStop.SetParentComponent(tabDaten);
    btnTourStop.Name := 'btnTourStop';
    btnTourStop.Left := 310;
    btnTourStop.Top := 7;
    btnTourStop.Width := 73;
    btnTourStop.Height := 44;
    btnTourStop.Cursor := crHandPoint;
    btnTourStop.ParentDoubleBuffered := False;
    btnTourStop.DoubleBuffered := True;
    btnTourStop.Font.Charset := ANSI_CHARSET;
    btnTourStop.Font.Color := clWindowText;
    btnTourStop.Font.Height := -13;
    btnTourStop.Font.Name := 'Verdana';
    btnTourStop.Font.Style := [];
    btnTourStop.ParentColor := True;
    btnTourStop.TabOrder := 2;
    SetEvent(btnTourStop, Self, 'OnClick', 'btnTourMeldungClick');
    btnTourStop.Text := 'Stop';
    btnTourStop.BitmapContainer := BitmapCont;
    btnTourStop.ControlIndex := 0;
    btnTourAktOK.SetParentComponent(tabDaten);
    btnTourAktOK.Name := 'btnTourAktOK';
    btnTourAktOK.Left := 17;
    btnTourAktOK.Top := 7;
    btnTourAktOK.Width := 73;
    btnTourAktOK.Height := 44;
    btnTourAktOK.Cursor := crHandPoint;
    btnTourAktOK.ParentDoubleBuffered := False;
    btnTourAktOK.DoubleBuffered := True;
    btnTourAktOK.Font.Charset := ANSI_CHARSET;
    btnTourAktOK.Font.Color := clWindowText;
    btnTourAktOK.Font.Height := -13;
    btnTourAktOK.Font.Name := 'Verdana';
    btnTourAktOK.Font.Style := [];
    btnTourAktOK.ParentColor := True;
    btnTourAktOK.TabOrder := 3;
    SetEvent(btnTourAktOK, Self, 'OnClick', 'btnTourAktionClick');
    btnTourAktOK.Text := 'OK';
    btnTourAktOK.BitmapContainer := BitmapCont;
    btnTourAktOK.ControlIndex := 0;
    btnTourAktNOK.SetParentComponent(tabDaten);
    btnTourAktNOK.Name := 'btnTourAktNOK';
    btnTourAktNOK.Left := 95;
    btnTourAktNOK.Top := 7;
    btnTourAktNOK.Width := 73;
    btnTourAktNOK.Height := 44;
    btnTourAktNOK.Cursor := crHandPoint;
    btnTourAktNOK.ParentDoubleBuffered := False;
    btnTourAktNOK.DoubleBuffered := True;
    btnTourAktNOK.Font.Charset := ANSI_CHARSET;
    btnTourAktNOK.Font.Color := clWindowText;
    btnTourAktNOK.Font.Height := -13;
    btnTourAktNOK.Font.Name := 'Verdana';
    btnTourAktNOK.Font.Style := [];
    btnTourAktNOK.ParentColor := True;
    btnTourAktNOK.TabOrder := 4;
    SetEvent(btnTourAktNOK, Self, 'OnClick', 'btnTourAktionClick');
    btnTourAktNOK.Text := 'NOK';
    btnTourAktNOK.BitmapContainer := BitmapCont;
    btnTourAktNOK.ControlIndex := 0;
    tabDoku.SetParentComponent(pgContr);
    tabDoku.Name := 'tabDoku';
    tabDoku.AlignWithMargins := True;
    tabDoku.Left := 0;
    tabDoku.Top := 43;
    tabDoku.Width := 518;
    tabDoku.Height := 393;
    tabDoku.Margins.Left := 0;
    tabDoku.Margins.Top := 43;
    tabDoku.Margins.Right := 0;
    tabDoku.Margins.Bottom := 0;
    tabDoku.Align := alClient;
    tabDoku.ParentDoubleBuffered := False;
    tabDoku.Color := 16776441;
    tabDoku.DoubleBuffered := True;
    tabDoku.TabStop := False;
    tabDoku.TabOrder := 0;
    tabDoku.Fill.Color := 16776441;
    tabDoku.PageIndex := 2;
    tabDoku.IsActive := True;
    ImgContr.SetParentComponent(tabDoku);
    ImgContr.Name := 'ImgContr';
    ImgContr.Left := 3;
    ImgContr.Top := 138;
    ImgContr.Width := 512;
    ImgContr.Height := 252;
    ImgContr.WidthStyle := ssAuto;
    ImgContr.HeightPercent := 100.000000000000000000;
    ImgContr.WidthPercent := 100.000000000000000000;
    ImgContr.Anchors := [akLeft,akTop,akRight,akBottom];
    ImgContr.ChildOrder := 1;
    SetEvent(ImgContr, Self, 'OnDblClick', 'ImgContrDblClick');
    lbDokumentPos.SetParentComponent(tabDoku);
    lbDokumentPos.Name := 'lbDokumentPos';
    lbDokumentPos.Left := 410;
    lbDokumentPos.Top := 35;
    lbDokumentPos.Width := 22;
    lbDokumentPos.Height := 16;
    lbDokumentPos.Caption := '0/0';
    lbDokumentPos.Color := 16776441;
    lbDokumentPos.HeightPercent := 100.000000000000000000;
    lbDokumentPos.WidthPercent := 100.000000000000000000;
    fpFilePicker.SetParentComponent(tabDoku);
    fpFilePicker.Name := 'fpFilePicker';
    fpFilePicker.Left := 14;
    fpFilePicker.Top := 96;
    fpFilePicker.Width := 407;
    fpFilePicker.Height := 36;
    fpFilePicker.Accept := 'image/*';
    fpFilePicker.ChildOrder := 1;
    SetEvent(fpFilePicker, Self, 'OnChange', 'fpFilePickerChange');
    SetEvent(fpFilePicker, Self, 'OnGetFileAsBase64', 'fpFilePickerGetFileAsBase64');
    cbxDokumente.SetParentComponent(tabDoku);
    cbxDokumente.Name := 'cbxDokumente';
    cbxDokumente.Left := 14;
    cbxDokumente.Top := 57;
    cbxDokumente.Width := 407;
    cbxDokumente.Height := 24;
    cbxDokumente.Cursor := crHandPoint;
    cbxDokumente.HeightStyle := ssAuto;
    cbxDokumente.HeightPercent := 100.000000000000000000;
    cbxDokumente.WidthPercent := 100.000000000000000000;
    SetEvent(cbxDokumente, Self, 'OnChange', 'cbxDokumenteChange');
    cbxDokumente.ItemIndex := -1;
    btnDokumentDel.SetParentComponent(tabDoku);
    btnDokumentDel.Name := 'btnDokumentDel';
    btnDokumentDel.Left := 226;
    btnDokumentDel.Top := 7;
    btnDokumentDel.Width := 65;
    btnDokumentDel.Height := 44;
    btnDokumentDel.Cursor := crHandPoint;
    btnDokumentDel.ParentDoubleBuffered := False;
    btnDokumentDel.DoubleBuffered := True;
    btnDokumentDel.Font.Charset := ANSI_CHARSET;
    btnDokumentDel.Font.Color := clWindowText;
    btnDokumentDel.Font.Height := -13;
    btnDokumentDel.Font.Name := 'Verdana';
    btnDokumentDel.Font.Style := [];
    btnDokumentDel.ParentColor := True;
    btnDokumentDel.TabOrder := 2;
    SetEvent(btnDokumentDel, Self, 'OnClick', 'btnDokumentDelClick');
    btnDokumentDel.Text := '';
    btnDokumentDel.TextVisible := False;
    btnDokumentDel.Bitmaps.Clear;
    with btnDokumentDel.Bitmaps.Add do
    begin
      BitmapName := 'DEL';
    end;
    btnDokumentDel.BitmapVisible := True;
    btnDokumentDel.BitmapContainer := BitmapCont;
    btnDokumentDel.ControlIndex := 0;
    btnNavNext.SetParentComponent(tabDoku);
    btnNavNext.Name := 'btnNavNext';
    btnNavNext.Left := 81;
    btnNavNext.Top := 7;
    btnNavNext.Width := 65;
    btnNavNext.Height := 44;
    btnNavNext.Cursor := crHandPoint;
    btnNavNext.ParentDoubleBuffered := False;
    btnNavNext.DoubleBuffered := True;
    btnNavNext.Font.Charset := DEFAULT_CHARSET;
    btnNavNext.Font.Color := clWindowText;
    btnNavNext.Font.Height := -11;
    btnNavNext.Font.Name := 'Segoe UI';
    btnNavNext.Font.Style := [];
    btnNavNext.ParentColor := True;
    btnNavNext.TabOrder := 3;
    SetEvent(btnNavNext, Self, 'OnClick', 'DoDokumentNav');
    btnNavNext.Text := '';
    btnNavNext.Bitmaps.Clear;
    with btnNavNext.Bitmaps.Add do
    begin
      BitmapName := 'RECHTS';
    end;
    btnNavNext.BitmapVisible := True;
    btnNavNext.BitmapContainer := BitmapCont;
    btnNavNext.ControlIndex := 0;
    btnNavPrev.SetParentComponent(tabDoku);
    btnNavPrev.Name := 'btnNavPrev';
    btnNavPrev.Left := 14;
    btnNavPrev.Top := 7;
    btnNavPrev.Width := 65;
    btnNavPrev.Height := 44;
    btnNavPrev.Cursor := crHandPoint;
    btnNavPrev.ParentDoubleBuffered := False;
    btnNavPrev.DoubleBuffered := True;
    btnNavPrev.Font.Charset := DEFAULT_CHARSET;
    btnNavPrev.Font.Color := clWindowText;
    btnNavPrev.Font.Height := -11;
    btnNavPrev.Font.Name := 'Segoe UI';
    btnNavPrev.Font.Style := [];
    btnNavPrev.ParentColor := True;
    btnNavPrev.TabOrder := 4;
    SetEvent(btnNavPrev, Self, 'OnClick', 'DoDokumentNav');
    btnNavPrev.Text := '';
    btnNavPrev.Bitmaps.Clear;
    with btnNavPrev.Bitmaps.Add do
    begin
      BitmapName := 'LINKS';
    end;
    btnNavPrev.BitmapVisible := True;
    btnNavPrev.BitmapContainer := BitmapCont;
    btnNavPrev.ControlIndex := 0;
    btnAkt.SetParentComponent(tabDoku);
    btnAkt.Name := 'btnAkt';
    btnAkt.Left := 154;
    btnAkt.Top := 7;
    btnAkt.Width := 65;
    btnAkt.Height := 44;
    btnAkt.Cursor := crHandPoint;
    btnAkt.ParentDoubleBuffered := False;
    btnAkt.DoubleBuffered := True;
    btnAkt.Font.Charset := ANSI_CHARSET;
    btnAkt.Font.Color := clWindowText;
    btnAkt.Font.Height := -13;
    btnAkt.Font.Name := 'Verdana';
    btnAkt.Font.Style := [];
    btnAkt.ParentColor := True;
    btnAkt.TabOrder := 5;
    SetEvent(btnAkt, Self, 'OnClick', 'btnAktClick');
    btnAkt.Text := '';
    btnAkt.TextVisible := False;
    btnAkt.Bitmaps.Clear;
    with btnAkt.Bitmaps.Add do
    begin
      BitmapName := 'AKT';
    end;
    btnAkt.BitmapVisible := True;
    btnAkt.BitmapContainer := BitmapCont;
    btnAkt.ControlIndex := 0;
    btnDownload.SetParentComponent(tabDoku);
    btnDownload.Name := 'btnDownload';
    btnDownload.Left := 299;
    btnDownload.Top := 7;
    btnDownload.Width := 65;
    btnDownload.Height := 44;
    btnDownload.Cursor := crHandPoint;
    btnDownload.ParentDoubleBuffered := False;
    btnDownload.DoubleBuffered := True;
    btnDownload.Font.Charset := ANSI_CHARSET;
    btnDownload.Font.Color := clWindowText;
    btnDownload.Font.Height := -13;
    btnDownload.Font.Name := 'Verdana';
    btnDownload.Font.Style := [];
    btnDownload.ParentColor := True;
    btnDownload.TabOrder := 6;
    SetEvent(btnDownload, Self, 'OnClick', 'btnPDFClick');
    btnDownload.Text := '';
    btnDownload.TextVisible := False;
    btnDownload.Bitmaps.Clear;
    with btnDownload.Bitmaps.Add do
    begin
      BitmapName := 'DOWNLOAD';
    end;
    btnDownload.BitmapVisible := True;
    btnDownload.BitmapContainer := BitmapCont;
    btnDownload.ControlIndex := 0;
    tabSprachDaten.Left := 133;
    tabSprachDaten.Top := 328;
  finally
    WebPanel1.AfterLoadDFMValues;
    lbTau.AfterLoadDFMValues;
    lbBeladung.AfterLoadDFMValues;
    lbEntladung.AfterLoadDFMValues;
    edtTourRef.AfterLoadDFMValues;
    edtBeginn.AfterLoadDFMValues;
    edtEnde.AfterLoadDFMValues;
    lbFzg1.AfterLoadDFMValues;
    lbFzg2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    btnOK.AfterLoadDFMValues;
    btnAbbrechen.AfterLoadDFMValues;
    pgContr.AfterLoadDFMValues;
    tabTau.AfterLoadDFMValues;
    respGrid.AfterLoadDFMValues;
    tabEmpfang.AfterLoadDFMValues;
    sigCapt.AfterLoadDFMValues;
    btnSignaturSpeichern.AfterLoadDFMValues;
    mInfoSign.AfterLoadDFMValues;
    tabDaten.AfterLoadDFMValues;
    mDaten.AfterLoadDFMValues;
    btnTourStart.AfterLoadDFMValues;
    btnTourStop.AfterLoadDFMValues;
    btnTourAktOK.AfterLoadDFMValues;
    btnTourAktNOK.AfterLoadDFMValues;
    tabDoku.AfterLoadDFMValues;
    ImgContr.AfterLoadDFMValues;
    lbDokumentPos.AfterLoadDFMValues;
    fpFilePicker.AfterLoadDFMValues;
    cbxDokumente.AfterLoadDFMValues;
    btnDokumentDel.AfterLoadDFMValues;
    btnNavNext.AfterLoadDFMValues;
    btnNavPrev.AfterLoadDFMValues;
    btnAkt.AfterLoadDFMValues;
    btnDownload.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
  end;
end;

end.
